import { entries, filter, join, map, pipe } from '@fxts/core';
import { AT } from '../translation';

export const makeLoginUrl = (client_id: string, option?: { destination_url?: string }) => {
  const params = pipe(
    { ...(option ?? {}), client_id },
    entries,
    filter(([_, v]) => !!v),
    map(([k, v]) => (v ? `${k}=${encodeURIComponent(v)}` : '')),
    join('&'),
  );
  return `/${AT.language}/login?${params}`;
};

export const makeResultUrl = (client_id: string, option?: { signup?: boolean; sns_connect?: boolean }) => {
  const params = pipe(
    { ...(option ?? {}), client_id },
    entries,
    filter(([_, v]) => !!v),
    map(([k, v]) => (v ? `${k}=${encodeURIComponent(v)}` : '')),
    join('&'),
  );
  return `/${AT.language}/result?${params}`;
};

export const makeAgreeTermsUrl = (client_id: string) => {
  return `/${AT.language}/agreement?client_id=${client_id}`;
};

export const makeEmailVerifyUrl = (client_id: string, url: string) => {
  return `/${AT.language}/verify/email?client_id=${client_id}&url=${encodeURIComponent(url)}`;
};

export const makeSnsEmailVerifyUrl = (client_id: string, url: string) => {
  return `/${AT.language}/verify/email/sns/?client_id=${client_id}&url=${encodeURIComponent(url)}`;
};
